import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;

const getInitialIsMobile = () => {
  const maxWidth = MOBILE_BREAKPOINT - 1;
  if (typeof window.matchMedia === 'function') {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
  }

  return window.innerWidth < MOBILE_BREAKPOINT;
};

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean>(() => getInitialIsMobile());

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    ) {
      return;
    }

    const maxWidth = MOBILE_BREAKPOINT - 1;
    const mql = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const onChange = () => setIsMobile(mql.matches);

    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
